import { FC, useEffect, useState } from "react";

import { AreaAdditionItemDisplay } from "./area-addition.item.display";
import { AreaAdditionItemEdit } from "./area-addition.item.edit";
import { IAreaAdditionItemForm } from "./area-addition.models";

export const AreaAdditionItem: FC<IAreaAdditionItemForm> = ({
  fieldName,
  index,
  value,
  control,
  setValue,
  getValues,
  removeHandler,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <div className={!inEdit ? "display-mode" : undefined}>
      {!inEdit && (
        <AreaAdditionItemDisplay
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          control={control}
          removeHandler={removeHandler}
          index={index}
          value={value}
          onEdit={() => {
            setInEdit(true);
          }}
        />
      )}

      {inEdit && (
        <AreaAdditionItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          index={index}
          value={value}
          onCancel={() => {
            setInEdit(false);
          }}
        />
      )}
    </div>
  );
};
